export const strings = {
    prefixAgo: 'pirms',
    prefixFromNow: null,
    suffixAgo: null,
    suffixFromNow: 'no šī brīža',
    seconds: '%d sek.',
    minute: 'min.',
    minutes: '%d min.',
    hour: 'st.',
    hours: '%d st.',
    day: '1 d.',
    days: '%d d.',
    month: 'mēnesis.',
    months: '%d mēnesis.',
    year: 'gads',
    years: '%d gads',
    wordSeparator: ' ',
};
